import { Routes, RouterModule } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [

  
  {
    path: 'pages',
    loadChildren: () => import('../../menu_tmp/pages/full-pages/full-pages.module').then(m => m.FullPagesModule)
  },

  
  {
    path: 'dashboard',
    loadChildren: () => import('../../menu/dashboard/dashboard.module').then(m => m.DashboardModule)
  },

  /*
  {
    path: 'calendar',
    loadChildren: () => import('../../menu_tmp/calendar/calendar.module').then(m => m.CalendarsModule)
  },
  
  {
    path: 'charts',
    loadChildren: () => import('../../menu_tmp/charts/charts.module').then(m => m.ChartsNg2Module)
  },
   {
    path: 'forms',
    loadChildren: () => import('../../menu_tmp/forms/forms.module').then(m => m.FormModule)
  },
  {
    path: 'maps',
    loadChildren: () => import('../../menu_tmp/maps/maps.module').then(m => m.MapsModule)
  },
  {
    path: 'tables',
    loadChildren: () => import('../../menu_tmp/tables/tables.module').then(m => m.TablesModule)
  },
  {
    path: 'datatables',
    loadChildren: () => import('../../menu_tmp/data-tables/data-tables.module').then(m => m.DataTablesModule)
  },
  {
    path: 'uikit',
    loadChildren: () => import('../../menu_tmp/ui-kit/ui-kit.module').then(m => m.UIKitModule)
  },
  {
    path: 'components',
    loadChildren: () => import('../../components/ui-components.module').then(m => m.UIComponentsModule)
  },
  {
    path: 'cards',
    loadChildren: () => import('../../menu_tmp/cards/cards.module').then(m => m.CardsModule)
  },
  {
    path: 'chat',
    loadChildren: () => import('../../menu_tmp/chat/chat.module').then(m => m.ChatModule)
  },
  {
    path: 'chat-ngrx',
    loadChildren: () => import('../../menu_tmp/chat-ngrx/chat-ngrx.module').then(m => m.ChatNGRXModule)
  },
  {
    path: 'inbox',
    loadChildren: () => import('../../menu_tmp/inbox/inbox.module').then(m => m.InboxModule)
  },
  {
    path: 'taskboard',
    loadChildren: () => import('../../menu_tmp/taskboard/taskboard.module').then(m => m.TaskboardModule)
  },
  {
    path: 'taskboard-ngrx',
    loadChildren: () => import('../../menu_tmp/taskboard-ngrx/taskboard-ngrx.module').then(m => m.TaskboardNGRXModule)
  }
  */
];
